import { isEmpty } from 'lodash'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useWindowSize } from 'react-use'
import styled from 'styled-components'
import Modal from 'components/modal'
import Typography from 'components/typography'
import Button from 'components/button'
import CourseConfirmModal from '../../components/courseConfirmModal'
import getImageUrl from 'utils/getImageUrl'
// import EnrollModal from 'components/enrollModal'
// import CheckCircle from './CheckCircle.svg'

const Container = styled.div`
  min-width: 150px;
`
const Div = styled.div`
  padding: 29px 25px 33px 24px;
  @media (max-width: 426px) {
    padding: 24px 27px;
  }
`
// const Div2 = styled.div`
//   padding: 40px 24px 33px 24px;
//   p + p {
//     margin: 0px 0px 50px 0px;
//   }
//   @media (min-width: 426px) {
//     div {
//       display: flex;
//       justify-content: space-evenly;
//     }
//   }
//   @media (max-width: 425px) {
//     padding: 12px 28px 24px 28px;
//     p + p {
//       margin-bottom: 24px;
//     }
//     div {
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       gap: 8px;
//       button {
//         width: 232px;
//       }
//     }
//   }
// `

const Title = styled((props) => <Typography {...props} />)`
  font-size: ${({ theme }) => theme['text-xl']};
  margin-bottom: 24px;
  font-weight: 500;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme['text-base']};
  }
`
const CourseButton = ({
  enrolledStatus,
  // Confirm,
  onEnroll,
  gotoTop,
  courseId,
  courseName,
  inviteCode,
  courseImage,
  noModal = false,
  handleLoginModal,
  appUser,
  prerequisiteResult = {},
  locale,
  courseMode,
  isFooter,
  ...props
}) => {
  const { width } = useWindowSize()
  const [isOpenAlert, setIsOpenAlert] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const getButtonStyle = () => {
    if (width <= 425) {
      return {
        full: true,
        height: 37,
        fontStyle: { fontSize: 14, fontWeight: 700 },
        borderRadius: 4,
      }
    }
    if (isFooter) {
      return { full: true }
    }
    return {
      full: true,
      height: 60,
      fontStyle: { fontSize: 20, fontWeight: 600 },
      borderRadius: 10,
    }
  }

  const buttonStyleProps = getButtonStyle()

  const viewCourse = () => {
    const { history } = props
    history.push(`/my-course/courses/${courseId}`)
  }

  const viewAsTeacher = () => {
    const { history, schoolId } = props
    history.push(`/schools/${schoolId}/curriculum/manage/${courseId}`)
  }

  const handleOpenModal = () => {
    // Confirm.open({
    //   titleNoMargin: 'Do you confirm to enroll this course?',
    //   titleNoMarginId: 'modal.course.enroll.confirm',
    //   title2: courseName,
    //   image: getImageUrl(courseImage),
    //   onCancel: () => {
    //     Confirm.close()
    //   },
    //   onConfirm: () => {
    //     Confirm.close()
    //     onEnroll()
    //   },
    // })
    setIsOpenModal(true)
  }

  const handleOpenAlert = () => {
    setIsOpenAlert(true)
  }

  const checkConditionModal = () => {
    if (noModal) {
      gotoTop()
    } else if (isEmpty(appUser)) {
      handleLoginModal()
    } else if (prerequisiteResult.isPassed) {
      handleOpenModal()
    } else {
      handleOpenAlert()
    }
  }

  return (
    <Container>
      {enrolledStatus === 'teaching' && (
        <Button
          id="button.view.instructor"
          {...buttonStyleProps}
          secondary
          onClick={viewAsTeacher}
          style={{ lineHeight: 1.1 }}
        >
          View as instructor
        </Button>
      )}
      {enrolledStatus === 'enrolled' && (
        <Button id="button.courseBtn" {...buttonStyleProps} primary onClick={viewCourse}>
          Go to Course
        </Button>
      )}
      {enrolledStatus === 'awaiting' && (
        <Button id="button.approve" {...buttonStyleProps} warning>
          Awaiting Approval
        </Button>
      )}
      {enrolledStatus === 'disabled' && (
        <Button id="button.enroll" {...buttonStyleProps} disabled>
          Enroll
        </Button>
      )}
      {enrolledStatus === 'full' && (
        <Button id="button.courseFull" {...buttonStyleProps} disabled>
          Course is full
        </Button>
      )}

      {(enrolledStatus === 'notEnroll' || enrolledStatus === 'notPaid') && (
        <Button
          id="button.enroll"
          primary={!inviteCode && courseMode === 'CODE' ? false : true}
          // primaryDisable={!inviteCode && courseMode === 'CODE' ? true : false}
          disabled={!inviteCode && courseMode === 'CODE' ? true : false}
          {...buttonStyleProps}
          style={{
            boxShadow: '5px 5px 10px #3C45A533',
          }}
          onClick={inviteCode === undefined && courseMode === 'CODE' ? null : checkConditionModal}
        >
          Enroll
        </Button>
      )}
      <CourseConfirmModal
        isOpen={isOpenModal}
        onRequestClose={() => setIsOpenModal(false)}
        onClickClose={isOpenModal}
      >
        <div>
          <img src={getImageUrl(courseImage)} alt="courseImg" style={{ width: '100%' }} />
          <Div>
            <Typography
              id="modal.course.enroll.confirm"
              color="primary10"
              margin="0px 0px 20px 0px"
            >
              Do you confirm to enroll this course?
            </Typography>
            <Typography color="black100" margin="0px 0px 20px 0px">
              {courseName}
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <Button color="primary1" cancelbtn onClick={() => setIsOpenModal(false)}>
                <Typography
                  id="modal.course.enroll.cancelBtn"
                  fontSize="text-base"
                  color="primary1"
                  bold
                >
                  Cancel
                </Typography>
              </Button>
              <Button
                confirmbtn
                onClick={() => {
                  setIsOpenModal(false)
                  onEnroll()
                }}
              >
                <Typography
                  id="modal.course.enroll.confirmBtn"
                  fontSize="text-base"
                  color="white"
                  bold
                >
                  Confirm
                </Typography>
              </Button>
            </div>
          </Div>
        </div>
      </CourseConfirmModal>
      {/* <EnrollModal
        isOpen={isOpenModal}
        onRequestClose={() => setIsOpenModal(false)}
        onClickClose={isOpenModal}
      >
        <img src={CheckCircle} alt="checkCircle" style={{ width: '200px' }} />
        <Div2>
          <Typography
            id="checkout.enrollment"
            color="primary10"
            margin="0px 0px 15px 0px"
            fontWeight="600px"
          >
            Enrollment Complete
          </Typography>
          <Typography id="checkout.subtitle" color="black" values={{ courseName }}>
            You have successfully enrolled {courseName}
          </Typography>
          <div>
            <Button color="primary1" cancelbtn onClick={() => setIsOpenModal(false)}>
              <Typography id="enrollment.card.browseBtn" fontSize="text-base" color="primary1" bold>
                Browse more course
              </Typography>
            </Button>
            <Button
              confirmbtn
              onClick={() => {
                setIsOpenModal(false)
              }}
            >
              <Typography
                id="enrollment.card.courseBtn"
                fontSize="text-base"
                color="white"
                bold
              >
                Go to course
              </Typography>
            </Button>
          </div>
        </Div2>
      </EnrollModal> */}
      <Modal isOpen={isOpenAlert}>
        <div>
          <Title id="modal.course.enroll.alert">
            Attention: Prior to enroll this course, you must complete the following course(s) :
          </Title>
          {(prerequisiteResult?.baseCourses || []).map((course) => (
            <a
              key={course.id}
              href={`${window.location.origin}/courses/${course.slug}`}
              target="_blank"
              rel="noreferrer"
            >
              <Typography fontSize="text-base" color="primary">
                • {course.name}
              </Typography>
            </a>
          ))}
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
            <Button primary onClick={() => setIsOpenAlert(false)}>
              {locale === 'th' ? 'ตกลง' : 'OK'}
            </Button>
          </div>
        </div>
      </Modal>
    </Container>
  )
}

CourseButton.propTypes = {
  enrolledStatus: PropTypes.string.isRequired,
}

const mapState = (state) => ({
  appUser: state.AppUser.appUser,
  prerequisiteResult: state.Enrollment.prerequisiteResult,
})
const mapDispatch = ({ Confirm }) => ({ Confirm })

export default connect(mapState, mapDispatch)(withRouter(CourseButton))
